var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "fixed-banner",
        {
          class: { disabled: _vm.loading },
          attrs: {
            id: "email-veriFication-banner",
            icon: false,
            type: _vm.bannerType,
            "position-fixed": _vm.positionFixed,
            "side-right": _vm.sideRight,
          },
        },
        [
          !_vm.emailSent
            ? _c("i18n", {
                attrs: {
                  path: "account.verification.validateEmailAddress",
                  tag: "span",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "linkText",
                      fn: function () {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "bold clickable",
                              on: {
                                click: function ($event) {
                                  return _vm.handleValidateEmail({
                                    isResent: false,
                                  })
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm.$t(
                                      "account.verification.validateYourEmailAddress"
                                    )
                                  ) +
                                  "\n      "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2292200246
                ),
              })
            : _c("i18n", {
                attrs: {
                  path: "account.verification.verifyEmailWithinValidationTime",
                  tag: "span",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "link",
                      fn: function () {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "bold clickable text-lowercase",
                              on: {
                                click: function ($event) {
                                  return _vm.handleValidateEmail({
                                    isResent: true,
                                  })
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.$t("global.actions.clickHere")) +
                                  "\n      "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1723306496
                ),
              }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }